export default __webpack_public_path__ + "static/media/disNotesIcon.b6588cf2.svg";